import * as React from 'react'
import './App.css'
import Routing from './Routing'
import { Provider } from 'mobx-react'
import LocalizationStore from './Stores/LocalizationStore'
import UserStore from './Stores/UserStore'
import UsersStore from './Stores/UsersStore'
import HttpActionsService from './Services/HttpActionsService'
import 'react-table/react-table.css'
import QuestionnairesStore from './Stores/QuestionnairesStore'
import EventsStore from './Stores/EventsStore'
import AuthService from './Services/AuthService'
import PaymentsStore from './Stores/PaymentsStore'
import ExternalDataStore from './Stores/ExternalDataStore'
import NotificationsStore from './Stores/NotificationsStore'
import SettingsStore from './Stores/SettingsStore'
import MerchantsStore from './Stores/MerchantsStore'
import AffiliatesStore from './Stores/AffiliatesStore'
import ActionsLocalService from './Services/ActionsLocalService'
import ExportStore from './Stores/ExportStore'
import ConfigStore from './Stores/ConfigStore'
import CreditsStore from './Stores/CreditsStore'

export default class App extends React.Component {

  localizationStore = LocalizationStore.getInstance()
  userStore = UserStore.getInstance()
  usersStore = UsersStore.getInstance()
  httpActionsService = HttpActionsService.getInstance()
  questionnairesStore = QuestionnairesStore.getInstance()
  notificationsStore = NotificationsStore.getInstance()
  paymentsStore = PaymentsStore.getInstance()
  eventsStore = EventsStore.getInstance()
  externalDataStore = ExternalDataStore.getInstance()
  settingsStore = SettingsStore.getInstance()
  merchantsStore = MerchantsStore.getInstance()
  affiliatesStore = AffiliatesStore.getInstance()
  actionsLocalService = ActionsLocalService.getInstance()
  exportStore = ExportStore.getInstance()
  configStore = ConfigStore.getInstance()
  creditsStore = CreditsStore.getInstance()

  constructor(props: any) {
    super(props)

    AuthService.getInstance().checkSessionAndRedirect()
  }

  render() {

    AuthService.getInstance().refreshStart()

    return (
      <Provider
        httpActionsService={this.httpActionsService}
        localizationStore={this.localizationStore}
        notificationsStore={this.notificationsStore}
        userStore={this.userStore}
        questionnairesStore={this.questionnairesStore}
        eventsStore={this.eventsStore}
        paymentsStore={this.paymentsStore}
        externalDataStore={this.externalDataStore}
        settingsStore={this.settingsStore}
        merchantsStore={this.merchantsStore}
        affiliatesStore={this.affiliatesStore}
        usersStore={this.usersStore}
        actionsLocalService={this.actionsLocalService}
        exportStore={this.exportStore}
        configStore={this.configStore}
        creditsStore={this.creditsStore}
      >
        <Routing />
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx